import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../utils/auth';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  
  // 如果正在加载用户认证状态，显示加载中
  if (loading) {
    return <div>{t('common.loading')}</div>;
  }
  
  // 如果用户未认证，重定向到登录页
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  // 否则正常渲染子组件
  return children;
};

export default PrivateRoute;
